import { Link } from "react-router-dom";

export default function Reference() {
	return (
		<div>
			<p>This is reference ! ! !</p>
			<br />
			<a href={"https://doc.rust-lang.org/book/ch15-00-smart-pointers.html"}>Smart Pointer</a>
			<Link to={"https://doc.rust-lang.org/book/ch16-03-shared-state.html"}>Arc for config</Link>
		</div>

	);
}
